
















// Importing components
import TheTownSelect from '@/components/addresses/TheTownSelect.vue';
import BaseSection from '@/ui/BaseSection.vue';

export default {
    name: 'TheMapRestaurants',
    components: {
        TheTownSelect,
        BaseSection,
    },
    props: {
        restaurant: Object,
    },
    data() {
        return {};
    },
};
